import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { IconOtherSearch } from '@doltech/icons/IconOtherSearch';
import { isNotEmpty } from '@doltech/utils/lib/text';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { Cell, Grid } from 'styled-css-grid';

import { Button } from '../../ButtonV2/ButtonV2';
import { colorsV2 } from '../../colors-v2';
import { FilterUpdateDTO } from '../store/filter.store';

interface SearchInputProps extends React.HTMLAttributes<HTMLInputElement> {
  onSearch: (val: FilterUpdateDTO) => void;
  disabled?: boolean;
  placeholder?: any;
}

export const SearchInput = ({ defaultValue, onSearch, disabled, ...rest }: SearchInputProps) => {
  const [value, setValue] = React.useState<string>(defaultValue as string);

  React.useEffect(() => {
    setValue(defaultValue as string);
  }, [defaultValue]);

  const hasValue = isNotEmpty(value);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSearch({ search: value, page: 1 });
      }}
    >
      <Container
        columns={hasValue ? '1fr max-content max-content' : '1fr max-content'}
        className={cl({ disabled })}
      >
        <Cell middle>
          <Input
            placeholder="Search"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            disabled={disabled}
            {...rest}
          />
        </Cell>
        {hasValue ? (
          <Cell middle>
            <Button.Icon
              size="small"
              type="secondary"
              variant="transparent"
              disabled={disabled}
              onClick={(e) => {
                setValue('');
                onSearch({ search: '', page: 1 });
              }}
            >
              <IconOtherClose color="black100" size={24} />
            </Button.Icon>
          </Cell>
        ) : null}
        <Cell middle>
          <SearchButton htmlType="submit" disabled={disabled} shape="rounded-rect">
            <IconOtherSearch size={24} color="white100" style={{ cursor: 'pointer' }} />
          </SearchButton>
        </Cell>
      </Container>
    </form>
  );
};

const SearchButton = styled(Button.Icon)`
  width: 40px !important;
  height: 40px !important;
  background: ${colorsV2.black80} !important;
  padding: 0 12px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`;

const Container = styled(Grid)`
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  background: ${colorsV2.gray10};
  border: 1px solid ${colorsV2.black10};
  padding-left: 8px;

  &.disabled {
    &,
    & input,
    & button {
      background: ${colorsV2.gray40};
      cursor: not-allowed;
    }
  }

  input {
    &::placeholder {
      color: ${colorsV2.gray80};
    }
  }
`;

export const Input = styled.input`
  width: 100%;
  outline: none;
  background: transparent;
  border: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
